export { default as component } from "../../../../src/routes/[prefix]/(main)/notification/+page.svelte";